import { defineComponent as _defineComponent } from 'vue'
import { ClientActivityReport, ClientActivityReportRequest } from 'ah-api-gateways';
import VChart from './VChart.vue';
import { makeThemedChartDataset, makeDoughnutChartOptions } from '../helpers/chartConfig';
import { linesColorGreen, linesColorGrey } from '../helpers/graphColors';
import { computed, reactive, watch } from 'vue';
import { useAhReportsState } from '..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { ChartOptions } from 'chart.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerClientsActivityChart',
  props: {
    fromDate: null,
    toDate: null,
    partnerId: { default: '' }
  },
  setup(__props: any) {

const props = __props as { fromDate: Date, toDate: Date, partnerId: string };

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: onRetryFromParentManager,
});

function onRetryFromParentManager(k: string) {
  if (k === 'loadData') {
    loadDates();
  }
}



const state = reactive({
  report: null as ClientActivityReport | null,
  options: makeDoughnutChartOptions() as ChartOptions,
  data: makeThemedChartDataset({
    labels: ['Active Accounts', 'Inactive Accounts'],
    colorNames: ['widgets-green', 'widgets-grey'],
  }),
  green: linesColorGreen,
  grey: linesColorGrey,
});

const reportsState = useAhReportsState();

const dates = computed(() => ({
  from: props.fromDate,
  to: props.toDate,
}));

function loadDates() {
  const filter: ClientActivityReportRequest = {
    from: props.fromDate,
    to: props.toDate,
  };

  if (props.partnerId) {
    filter.partnerId = [props.partnerId];
  }

  requestManager.manager
    .cancelAndNew('loadData', reportsState.services.client.getClientActivityReport(filter))
    .subscribe((response) => {
      state.data.datasets![0].data! = [response.active, response.inactive];

      // Force update by replacing prop reference entirely
      state.options = { ...state.options };
      state.data = { ...state.data };

      state.report = response;
    });
}

watch(
  () => dates,
  () => {
    loadDates();
  },
  {
    immediate: true,
    deep: true,
  }
);

const activePercentage = computed(() => {
  if (state.report) {
    if (state.report.total === 0) {
      return state.report.total.toFixed(1);
    }
    return ((state.report.active / state.report.total) * 100).toFixed(1);
  }
  return 0;
});

return { __sfc: true,requestManager, onRetryFromParentManager, props, state, reportsState, dates, loadDates, activePercentage, VChart }
}

})